import { Typography } from "@atoms";
import { Modal } from "antd";
import { useTranslation } from "react-i18next";

import { Content } from "./deleteModal.styles";

interface IDeleteModal {
  open: boolean,
  setOpen: (value: boolean) => void,
  title: string,
  text: string,
  onOk?: ((e: React.MouseEvent<HTMLButtonElement>) => void) | undefined,
}

function DeleteModal({ open, setOpen, title, text, onOk }: IDeleteModal) {
  const { t } = useTranslation();

  return (
    <Modal
      forceRender
      open={open}
      onCancel={() => setOpen(false)}
      closeIcon={null}
      onOk={onOk}
      zIndex={99999}
      styles={{ content: { background: "#F9F2EC" }, header: { background: "#F9F2EC" } }}
      cancelButtonProps={{ style: { background: "#F9F2EC" } }}
      cancelText={t("cancel")}
      okText={t("delete")}
      width={400}
      title={title}
      centered
    >
      <Content>
        <Typography as="h4">{text}</Typography>
      </Content>
    </Modal>
  )
}

export default DeleteModal;
